module.exports = __webpack_public_path__ + "img/1-4.ec94c8e6.webp";